import React from "react";
import { useVariation } from "src/services/VariationService";
import styles from "./styles.scss";

const NewsletterHero = () => {
  const titles = [
    "Get Access to Free Daily Betting Guides Used by 300,000+ Sports Bettors",
    "Free Daily Betting Guides To Help You Win",
    "Sign Up for Free Daily Betting Guides, Mispriced Lines, and Sports Offers To Help You Win",
  ];

  const title = useVariation("newsletter", titles);

  return (
    <section className="newsletter-hero">
      <div className="newsletter-container">
        <div className="newsletter-detail">
          <span className="newsletter-subtitle">Sign up for the betql daily newsletter</span>
          <h1 className="newsletter-title">{title}</h1>
        </div>
      </div>
      <style jsx>{styles}</style>
    </section>
  );
};
export default NewsletterHero;
